import { Box, Typography } from "@mui/material"
import type { FC } from "react"

interface ReadOnlyFieldProps {
  label: string
  value: string
}

const ReadOnlyField: FC<ReadOnlyFieldProps> = ({ label, value }) => (
  <Box className='flex items-center gap-1'>
    <Typography variant='body2' className='tracking-[0.17px] text-gray-900'>
      {label}:
    </Typography>
    <Typography variant='body2' className='text-gray-700'>
      {value}
    </Typography>
  </Box>
)

export default ReadOnlyField
